import React, {useEffect, useState} from 'react';
import { Modal, Form, Input, Select, Button } from 'antd';
import {EntityModelRequestRequestMethodEnum, EntityModelRequestStageEnum, RequestDto} from "../api";
import {getPathvariables} from "../utils/Utils";

const { Option } = Select;

const EditRequestModal = ({ visible, onCancel, onSave, request }) => {
    const [form] = Form.useForm();
    const [pathVariables, setPathVariables] = useState(request?.pathVariables || []);
    const [baseUrl, setBaseUrl] = useState(request?.baseUrl || '');
    const [modalTitle, setModalTitle] = useState("Request");

    const stages = Object.values(EntityModelRequestStageEnum);
    const requestMethods = Object.values(EntityModelRequestRequestMethodEnum);

    const handleSave = () => {
        form.validateFields()
            .then((values) => {
                let requestDto : RequestDto = {id: request?.id, baseUrl: values.baseUrl, name: values.name,
                    requestJson: values.requestJson, stage: values.stage, requestMethod: values.requestMethod} as RequestDto;
                onSave(requestDto);
                form.resetFields();
                setPathVariables([]);
            });
    };

    useEffect(()=> {
        form.resetFields();
        if(request){
            setBaseUrl(request.baseUrl);
            setModalTitle("Edit Request");
            form.setFieldsValue({
                name: request.name,
                requestJson: request.requestJson,
                baseUrl: request.baseUrl,
                stage: request.stage,
                requestMethod: request.requestMethod
            });
        } else {
            setModalTitle("New Request");
        }
    }, [request])

    useEffect(() => {
        setPathVariables(getPathvariables(baseUrl));
    }, [baseUrl]);

    const handleBaseUrlChange = (e) => {
        const newBaseUrl = e.target.value;
        setBaseUrl(newBaseUrl);
    };

    return (
        <Modal
            open={visible}
            title={modalTitle}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="save" type="primary" onClick={handleSave}>
                    Save
                </Button>,
            ]}
        >
            <Form
                form={form}
                layout="vertical"
            >
                <Form.Item name="name" label="Name">
                    <Input />
                </Form.Item>
                <Form.Item name="requestJson" label="Request JSON">
                    <Input.TextArea rows={4} />
                </Form.Item>
                <Form.Item name="baseUrl" label="Base URL">
                    <Input onChange={handleBaseUrlChange} value={baseUrl} />
                </Form.Item>
                <Form.Item name="stage" label="Stage">
                    <Select>
                        {stages.map(option => (
                            <Option key={option} value={option}>
                                {option}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name="requestMethod" label="Request Method">
                    <Select>
                        {requestMethods.map(option => (
                            <Option key={option} value={option}>
                                {option}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item label="Path Variables">
                    {pathVariables.join(', ')}
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditRequestModal;